import ToggleList from './toggle-list';

export default { ToggleList };



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2-toolkit/src/column-toggle/index.js